import { render, staticRenderFns } from "./SubordinateLeaveFront.vue?vue&type=template&id=130648d4"
import script from "./SubordinateLeaveFront.vue?vue&type=script&lang=js"
export * from "./SubordinateLeaveFront.vue?vue&type=script&lang=js"
import style0 from "./SubordinateLeaveFront.vue?vue&type=style&index=0&id=130648d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports